import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC2ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC2ByHealthTeamData {
	healthTeam?: HealthTeam;
	totalCitizens: number = 0;
	totalCitizensScore: number = 0;
	maxCitizensScore: number = 0;
	totalCitizensWithTwoYearsInPeriod: number = 0;
	totalCitizensWithTwoYearsInPeriodScore: number = 0;
	maxCitizensWithTwoYearsInPeriodScore: number = 0;
}

export async function getResumeIndicatorC2ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC2ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC2ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC2ByHealthTeamData>();
}
